export default __webpack_public_path__ + "static/media/scan.141e4d9a.png";